// extracted by mini-css-extract-plugin
module.exports = {"item_box":"item_box___1jdFb","item_content":"item_content___O8sVu","item_title":"item_title___3ksGd","item_subtitle":"item_subtitle___1CwQ4","item_status":"item_status___2fx5H"};